import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
// import config from './config';
import data from './data/data.json';

// styles
import './styles/graphic.scss';


/* develblock:start */
import meta from './data/meta.json';


// import myImage from './images/congress-house-floor-diagram.svg';
// import myImage2x from './images/sotu2x.webp';

const importAll = (r) => {
  const images = {};
  r.keys().forEach((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
};

const images = importAll(require.context('./images', false, /\.(webp|png|jpe?g|svg)$/));

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

function rez(initialWidth) {
  document.getElementById('img').style.maxWidth = `${meta.imageWidth}px`;
  const mImage = document.getElementById('mainImage');
  if (!mImage.classList.contains('loaded')) {
    mImage.src = images['sotu.webp'];
    mImage.srcset = `${images['sotu.webp']} 1x, ${images['sotu_2x.webp']} 2x`;
    mImage.classList.add('loaded');
  }
  const tgs = document.getElementById('tags');
  if (initialWidth < 736) {
    // const tgs = document.getElementById('tags');
    if (meta.mobileZoom && meta.mobileZoom !== 1) {
      mImage.style.height = `${meta.imageHeight * meta.mobileZoom}px`;
      tgs.style.width = `${(1 / meta.mobileZoom) * 100}%`;
      tgs.style.height = `${(1 / meta.mobileZoom) * 100}%`;
      tgs.style.transform = `scale(${(meta.mobileZoom)})`;
    } else {
      tgs.style.width = '100%';
      tgs.style.height = '100%';
      tgs.style.transform = 'scale(1)';
      mImage.style.height = `${meta.imageHeight}px`;
    }

    mImage.style.width = 'auto';
    mImage.style.maxWidth = 'auto';
  } else {
    tgs.style.width = '100%';
    tgs.style.height = '100%';
    tgs.style.transform = 'scale(1)';
    mImage.style.height = 'auto';
    mImage.style.width = '100%';
    mImage.style.maxWidth = `${meta.imageWidth}px`;
  }
}

window.onload = () => {
  rez(window.innerWidth);
  const tags = document.getElementById('tags');
  data.forEach((p) => {
    const pt = document.createElement('div');
    pt.style.left = `${p.X * 100}%`;
    pt.style.top = `${p.Y * 100}%`;
    const tagsMain = document.createElement('div');
    const tagBox = document.createElement('div');

    if (p.class) {
      const classN = [];
      p.class.split(' ').forEach((c) => {
        const spt = c.split('|');
        classN.push(spt[0]);
        if (spt[0] === 'frosted' && spt[1]) {
          const [bgc, cl] = [spt[1], spt[3]];
          tagBox.style.backgroundColor = bgc;
          tagBox.style.color = cl;
          tagBox.style.backdropFilter = `blur(${spt[2]})`;
        }
        if (spt[0] === 'filter' && spt[1]) {
          const filterName = spt[1];
          const filterValue = spt.slice(2).join(' ');
          pt.style.filter = `${filterName}(${filterValue})`;
        }
      });
      const jn = classN.join(' ');
      pt.className = jn;
      tagsMain.className = `tMain ${jn}`;
    } else {
      tagsMain.className = 'tMain';
    }

    // tagBox.style.transform = 'translate(0, -30px)';
    if (p.offset) {
      const ofs = p.offset.split(',');
      tagBox.style.transform = `translate(${ofs[0]}px, ${ofs[1]}px)`;
    }
    if (p.MaxWidth) {
      tagBox.style.maxWidth = `${p.MaxWidth}px`;
    }

    const description = p.Description
      ? `<p class='tagDesc'>${p.Description}</p>`
      : '';
    const color = p.ColorTag
      ? `<p class='tagColor'><span style="background-color:${p.ColorKey || '#DDD'}"></span>  ${p.ColorTag}</p>`
      : '';

    let image = '';
    if (p.image && images[`${p.image}.webp`]) {
      image = `<img src='${images[`${p.image}.webp`]}' alt='${p.Name}' class='profileImage'/>`;
      tagBox.classList.add('hasImage');
    }

    tagBox.innerHTML = `${image}<p class='tagName'>${p.Name}</p>${description}${color}`;
    tagsMain.appendChild(tagBox);

    const box = document.createElement('div');
    box.className = `arw ${p.arrowheadType ? p.arrowheadType : 'arrow'}`;
    box.innerHTML = '';
    let arwCode = '';
    let lineCode = '';
    if (p.arrowheadType === 'circle') {
      const cSize = p.arrowheadSize || 10;
      arwCode = `<svg style="bottom:-${cSize / 2}px;left:-${cSize / 2}px;width:${cSize}px; height:${cSize}px;" class="arwCircle" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ${cSize} ${cSize}"><circle cx="${cSize / 2}" cy="${cSize / 2}" r="${cSize / 2 - 2}"/></svg>`;
      lineCode = `<svg class="arwLine" xmlns="http://www.w3.org/2000/svg" width="16" height="34" viewBox="0 0 16 34" fill="none"><line x1="8" x2="8" y1="0" y2="${37 - cSize / 2}" stroke-width="2"></svg>`;
    } else if (p.arrowheadType === 'diamond') {
      const cSize = p.arrowheadSize || 10;
      arwCode = `<div class="arwDiamond"><div style="margin-top:${-cSize}px;width:${cSize}px; height:${cSize}px;"></div></div>`;
      lineCode = `<svg class="arwLine" xmlns="http://www.w3.org/2000/svg" width="16" height="34" viewBox="0 0 16 34" fill="none"><line x1="8" x2="8" y1="0" y2="${37 - cSize / 2}" stroke-width="2"></svg>`;
    } else {
      arwCode = '<svg class="arwLine" xmlns="http://www.w3.org/2000/svg" width="16" height="34" viewBox="0 0 16 34" fill="none"><line x1="8" x2="8" y1="480" y2="0"/ stroke-width="2"></svg>';
      lineCode = '<div class="arwHead"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 10"><path d="M7.3,8.9c.4.4,1,.4,1.4,0l6.4-6.4c.4-.4.4-1,0-1.4-.4-.4-1-.4-1.4,0l-5.7,5.7L2.3,1.1c-.4-.4-1-.4-1.4,0-.4.4-.4,1,0,1.4l6.4,6.4Z"/></svg></div>';
    }
    if (p.Alignment !== undefined) {
      // console.log(p.Name, p.Alignment);
      pt.classList.add(`align_${p.Alignment}`);
    }

    box.innerHTML = arwCode + lineCode;
    const ofs = p.offset.split(',');
    if ((ofs[1] !== 0)) {
      const el = box.querySelector('svg.arwLine');
      const nv = parseFloat(el.getAttribute('height')) + Math.abs(parseFloat(ofs[1]));
      el.setAttribute('height', nv);
      el.setAttribute('viewBox', `0 0 16 ${nv}`);
    }
    pt.appendChild(box);
    pt.appendChild(tagsMain);

    tags.appendChild(pt);
  });
  // necessary evil for right now

  if (window.parent) {
    tags.addEventListener('pointerdown', (e) => {
      const xPos = ((e.offsetX * 100) / tags.offsetWidth).toFixed(1);
      const yPos = ((e.offsetY * 100) / tags.offsetHeight).toFixed(1);
      const coordStr = `${xPos}%\t${yPos}%`;
      window.parent.postMessage({
        type: 'getCoords',
        data: { coords: coordStr },
      }, '*');
    });
  }


  if (process.env.NODE_ENV === 'development') {
    window.pymChild.sendHeight();
    // tags.addEventListener('pointerdown', (e) => {
    //   const xPos = ((e.offsetX * 100) / tags.offsetWidth).toFixed(1);
    //   const yPos = ((e.offsetY * 100) / tags.offsetHeight).toFixed(1);
    //   const coordStr = `${xPos}%\t${yPos}%`;
    //   navigator.clipboard
    //     .writeText(coordStr)
    //     .then(() => {
    //       console.log(`Copied to clipboard: ${coordStr}`);
    //     })
    //     .catch((err) => {
    //       console.error('Failed to copy:', err);
    //     });
    // });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  const aa = document.getElementById('imgCont');
  if (meta && meta.startScroll) {
    aa.scrollLeft = (aa.scrollWidth - aa.offsetWidth) * meta.startScroll;
  }


  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
    console.log('Zion:', zion);
  }
};

function draw(initialWidth) {
  rez(initialWidth);
  const aa = document.getElementById('imgCont');
  if (meta && meta.startScroll) {
    aa.scrollLeft = (aa.scrollWidth - aa.offsetWidth) * meta.startScroll;
  }
}
